import { client } from './client'
import type {
  EntityHistoryEntityType,
  EntityHistoryEntry,
  PagedResult,
  PaginationParams,
} from '@/types'

export const entityHistoryApi = {
  getAll: (
    projectId: string,
    entityType: EntityHistoryEntityType,
    entityId: string,
    params?: PaginationParams,
  ) =>
    client
      .get<PagedResult<EntityHistoryEntry>>(`/projects/${projectId}/history/${entityType}/${entityId}`, { params })
      .then(r => r.data),
}
